export function sanitizeDialerInput(value: string): string {
  let result = '';

  for (const char of value.trim()) {
    if (char >= '0' && char <= '9') {
      result += char;
      continue;
    }

    if ((char === '*' || char === '#') && !result.includes('+')) {
      result += char;
      continue;
    }

    if (char === '+' && result.length === 0) {
      result += '+';
    }
  }

  return result.slice(0, 20);
}

export function isLikelyResolvablePhone(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) return false;

  if (trimmed.startsWith('+')) {
    return /^\+[1-9]\d{7,14}$/.test(trimmed);
  }

  if (trimmed.startsWith('00')) {
    return /^00[1-9]\d{7,14}$/.test(trimmed);
  }

  return /^\d{10}$/.test(trimmed) || /^1\d{10}$/.test(trimmed);
}

export function shouldShowContactsSearchHint(params: {
  isPhoneInputFocused: boolean;
  isContactsFetching: boolean;
  dialTarget: string;
  hasResolvedSession: boolean;
}): boolean {
  if (!params.isPhoneInputFocused) return false;
  if (!params.isContactsFetching) return false;
  if (params.hasResolvedSession) return false;

  return params.dialTarget.trim().length >= 2;
}
